import React from "react";
import { motion } from "framer-motion";

export default function KineticHeadline({ lines = [], className = "", lineClassName = "", delay = 0, as = "h1" }) {
    const Tag = as;
    return (
        <Tag className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
                    <motion.span
                        className={`block will-change-transform ${lineClassName}`}
                        initial={{ y: "115%" }}
                        animate={{ y: "0%" }}
                        transition={{ duration: 1, delay: delay + i * 0.12, ease: [0.16, 1, 0.3, 1] }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </Tag>
    );
}
